<script lang="ts" setup>
  import { useLocale } from '@tundr/i18n';
  import { ButtonSize, ButtonVariant } from '../../Button/Button.types';
  import Button from '../../Button/Button.vue';
  import {
    applyButtonClass,
    applyFooterClass,
  } from './DropdownApplyFooter.css';
  import type {
    DropdownApplyFooterEmits,
    DropdownApplyFooterProps,
  } from './DropdownApplyFooter.types';

  defineProps<DropdownApplyFooterProps>();

  const emit = defineEmits<DropdownApplyFooterEmits>();

  const { t } = useLocale('ds-components');
</script>

<template>
  <div :class="applyFooterClass">
    <Button
      :class="applyButtonClass"
      :variant="ButtonVariant.Primary"
      :size="ButtonSize.SM"
      :disabled="disabled"
      :data-test-id="testId"
      @click="emit('apply')"
      >{{
        label ?? t('select.apply')
      }}</Button
    >
  </div>
</template>
